// Beacon payload shape and event-type constants. This is the wire contract
// between the browser SDK and the ingest service; the ingest service expands
// it into rum.events rows (see rum_schema.sql).
//
// Versioning: every beacon carries `v` (the schema version). Bump
// SCHEMA_VERSION when payload shape changes; the server treats unknown
// versions as a soft drop, logged.

export const SCHEMA_VERSION = Number('__SCHEMA_VERSION__') || 1;
export const SDK_NAME = 'ambilobe-web';
export const SDK_VERSION = '__SDK_VERSION__';

// Mirrors rum.events.event_type. Keep in sync.
export const EVENT_TYPES = Object.freeze({
  PAGE_VIEW: 'page_view',
  WEB_VITAL: 'web_vital',
  NAV_TIMING: 'navigation_timing',
  RESOURCE_TIMING: 'resource_timing',
  LONG_TASK: 'long_task',
  ERROR: 'error',
  CUSTOM_ACTION: 'custom_action',
  INTERACTION: 'interaction'
});

// Shorten field names on the wire — RUM beacons run hot. The server is
// authoritative for the mapping; do not change without coordinating.
//
//   wire field  -> rum.events column
//   ----------     ------------------
//   t           -> timestamp (ms)
//   tp          -> event_type
//   n           -> event_name
//   mv          -> metric_value
//   mu          -> metric_unit
//   mr          -> metric_rating
//   mnt         -> metric_navigation_type
//   dim         -> dimensions (Map)
//   met         -> metrics (Map)
//   tag         -> tags
//
// Nav-timing / resource-timing / error fields keep their long names because
// they are sent per-event, not on every beacon.
export function buildEnvelope(ctx, events) {
  return {
    v: SCHEMA_VERSION,
    app: ctx.appId,
    env: ctx.environment,
    rel: ctx.release || '',
    sdk: { n: SDK_NAME, v: SDK_VERSION },
    sent_at: Date.now(),
    ctx: {
      aid:  ctx.anonymousId,
      uid:  ctx.userId || '',
      sid:  ctx.sessionId,
      vid:  ctx.viewId,
      ssa:  ctx.sessionStartedAt,
      ns:   ctx.isNewSession ? 1 : 0,
      nu:   ctx.isNewUser ? 1 : 0,
      url:  ctx.url,
      ref:  ctx.referrer || '',
      rt:   ctx.routeName || '',
      ua:   ctx.userAgent || '',
      uah:  ctx.userAgentHints || null,
      vw:   ctx.viewportWidth, vh: ctx.viewportHeight,
      sw:   ctx.screenWidth,   sh: ctx.screenHeight,
      dpr:  ctx.devicePixelRatio,
      loc:  ctx.locale,
      tz:   ctx.timezone,
      mem:  ctx.deviceMemoryGB,
      net:  ctx.connection,
      vis:  ctx.visibilityState,
      csn:  ctx.consentState || ''
    },
    e: events
  };
}
